'use client';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { getGridGutterStyle } from './mixins/getGutterStyle.js';

const StyledFlexGrid = styled.div.withConfig({
  componentId: "sc-2hj3yd-0"
})(["", ";", ";display:flex;flex-wrap:wrap;", ";", ""], defaultStyles.boxSizing, defaultStyles.fontSmoothing, ({
  gutter
}) => typeof gutter !== 'undefined' && getGridGutterStyle(gutter), ({
  spaceAfter
}) => spaceProp(spaceAfter));
const FlexGrid = /*#__PURE__*/withTitan(({
  children,
  gutter,
  spaceAfter,
  className,
  testId = 'grid'
}) => {
  const clonedChildrenWithProps = children ? React.Children.map(children, child => React.cloneElement(child, {
    gutter
  })) : children;
  return jsx(StyledFlexGrid, {
    className: className,
    "data-test-id": testId,
    gutter: gutter,
    spaceAfter: spaceAfter,
    children: clonedChildrenWithProps
  });
}, {
  name: 'FlexGrid'
});

export { FlexGrid };
//# sourceMappingURL=FlexGrid.js.map
